import * as signalR from '@aspnet/signalr';
import store from '../store';

let signalRConnection: signalR.HubConnection;
let reconnectTimeoutId: ReturnType<typeof setTimeout> | null = null;
let reconnectAttempts = 0;
const MAX_RECONNECT_DELAY_MS = 60000;
const BASE_RECONNECT_DELAY_MS = 5000;

async function connect(conn: any) {
  // Cancel any pending retry so we don't stack timeouts.
  if (reconnectTimeoutId !== null) {
    clearTimeout(reconnectTimeoutId);
    reconnectTimeoutId = null;
  }

  conn
    .start()
    .then(() => {
      reconnectAttempts = 0; // Reset on successful connect.
    })
    .catch((e: any) => {
      console.error(e);
      const delay = Math.min(
        BASE_RECONNECT_DELAY_MS * Math.pow(2, reconnectAttempts),
        MAX_RECONNECT_DELAY_MS
      );
      reconnectAttempts++;
      reconnectTimeoutId = setTimeout(() => {
        reconnectTimeoutId = null;
        connect(conn);
      }, delay);
    });
}

let initialized = false;

export default {
  init() {
    // Prevent duplicate init — avoids stacking onclose handlers.
    if (initialized && signalRConnection) {
      return;
    }

    const token: string = store.getters.token;
    signalRConnection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_HUB_ROOT + '/agmhub', {
        accessTokenFactory: () => token,
      })
      .build();
    signalRConnection.onclose((err: any) => {
      connect(signalRConnection);
    });
    initialized = true;
    connect(signalRConnection);
  },
  getConnection() {
    return signalRConnection;
  },
};
